export default __webpack_public_path__ + "static/media/B2B - Preview 1.f3a8862b.png";